import React from 'react';

import { TagOutlined } from '@ant-design/icons';
import { SelectProps } from 'antd';
import styled from 'styled-components';

import Select from 'components/lib/Select';

import {
  CreateEditActionPlansModalSelect,
  CreateEditActionPlansModalSelectLabel,
  CreateEditActionPlansModalSelectOptionLabel,
} from './CreateEditActionPlansModalSelectStyles';
import { SelectOption } from './CreateEditActionPlansModalTypes';

const DepartmentIcon = styled(TagOutlined)`
  font-size: 14px;
  flex-shrink: 0;
  color: var(--text-primary);
  transform: rotate(45deg);

  .selected & {
    color: var(--active-blue);
  }
`;

type Props = SelectProps & {
  itemTypeOptions: SelectOption[];
};

const CreateEditActionPlansModalDepartmentSelect = ({ itemTypeOptions, ...selectProps }: Props) => {
  return (
    <CreateEditActionPlansModalSelect
      allowClear
      className="rectangular"
      labelRender={({ label }) => (
        <CreateEditActionPlansModalSelectLabel className="selected">
          <DepartmentIcon />
          {label}
        </CreateEditActionPlansModalSelectLabel>
      )}
      optionLabelProp="label"
      placeholder={
        <CreateEditActionPlansModalSelectLabel>
          <DepartmentIcon />
          Department
        </CreateEditActionPlansModalSelectLabel>
      }
      suffixIcon={null}
      {...selectProps}
    >
      {itemTypeOptions.map((itemTypeOption) => (
        <Select.Option key={itemTypeOption.value} value={itemTypeOption.value} label={itemTypeOption.label}>
          <CreateEditActionPlansModalSelectOptionLabel>
            {itemTypeOption.label}
          </CreateEditActionPlansModalSelectOptionLabel>
        </Select.Option>
      ))}
    </CreateEditActionPlansModalSelect>
  );
};

export default CreateEditActionPlansModalDepartmentSelect;
